module.exports = __webpack_public_path__ + "img/emo_44.9647605c.png";